import { Component } from '@angular/core';

@Component({
  selector: 'app-word-png-content',
  imports: [],
  templateUrl: './word-png-content.component.html',
  styleUrl: './word-png-content.component.css'
})
export class WordPngContentComponent {

}
